(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/legal-info/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/legal-info/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.legal_info = svs.legal_info || {};
svs.legal_info.jotai = svs.legal_info.jotai || {};
svs.legal_info.hooks = svs.legal_info.hooks || {};
svs.legal_info.components = svs.legal_info.components || {};
svs.legal_info.components.login_check = svs.legal_info.components.login_check || {};
svs.legal_info.components.login_check.self_exclusion_info = svs.legal_info.components.login_check.self_exclusion_info || {};
svs.legal_info.components.login_check.check_terms = svs.legal_info.components.login_check.check_terms || {};

 })(window);